/**
 * Bezpieczne formatowanie błędów z API/FastAPI
 *
 * Wyodrębnione z: /app/frontend/src/pages/settings/KsefSettingsPage.jsx (linie 24-64)
 *
 * Zapobiega crashowi React gdy backend zwróci obiekt walidacyjny FastAPI
 * (Pydantic ValidationError jest obiektem, nie stringiem).
 */

/**
 * Bezpieczna konwersja błędu na string.
 * Obsługuje: string, error.message, error.error_message, error.msg,
 * error.detail (string/array of {msg}), nieznane obiekty (JSON.stringify).
 */
export const safeErrorMessage = (err) => {
  if (!err) return null;
  if (typeof err === "string") return err;
  if (err.error_message) return String(err.error_message);
  if (err.message) return String(err.message);
  if (err.msg) return String(err.msg);
  if (err.detail) {
    if (typeof err.detail === "string") return err.detail;
    if (Array.isArray(err.detail) && err.detail[0]?.msg) return String(err.detail[0].msg);
    if (Array.isArray(err.detail)) {
      try {
        return err.detail.map(d => d.msg || JSON.stringify(d)).join("; ");
      } catch {
        return "Błąd walidacji";
      }
    }
  }
  try {
    return JSON.stringify(err);
  } catch {
    return "Nieznany błąd";
  }
};

/**
 * Bezpieczna konwersja response.data.detail (FastAPI HTTPException body) na string.
 */
export const safeDetailMessage = (response) => {
  if (!response?.data?.detail) return null;
  const detail = response.data.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return String(detail[0].msg);
  if (Array.isArray(detail)) {
    return detail.map(d => d.msg || JSON.stringify(d)).join("; ");
  }
  try {
    return JSON.stringify(detail);
  } catch {
    return "Błąd";
  }
};
